(function () {
  var TURKISH_DAYS = ['PAZAR', 'PAZARTESİ', 'SALI', 'ÇARŞAMBA', 'PERŞEMBE', 'CUMA', 'CUMARTESİ'];
  var WEEKDAY_CUTOFF = 15 * 60;
  var SATURDAY_CUTOFF = 11 * 60;
  var DELIVERY_DAYS_AFTER_SHIP = 2;

  function getIstanbulParts(date) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
    var parts = fmt.formatToParts(date);
    var map = {};
    parts.forEach(function (p) {
      map[p.type] = p.value;
    });
    return {
      year: parseInt(map.year, 10),
      month: parseInt(map.month, 10),
      day: parseInt(map.day, 10),
      hour: parseInt(map.hour, 10),
      minute: parseInt(map.minute, 10),
    };
  }

  function dateAtNoon(y, m, d) {
    return new Date(y, m - 1, d, 12, 0, 0);
  }

  function addCalendarDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function getWeekdayIndex(date) {
    return date.getDay();
  }

  function nextBusinessDay(fromDate) {
    var cursor = addCalendarDays(fromDate, 1);
    while (getWeekdayIndex(cursor) === 0 || getWeekdayIndex(cursor) === 6) {
      cursor = addCalendarDays(cursor, 1);
    }
    return cursor;
  }

  /**
   * Kargo kuralları (Europe/Istanbul):
   * - Hafta içi 15:00'a kadar: aynı gün kargo
   * - Hafta içi 15:00 sonrası: ertesi iş günü
   * - Cumartesi 11:00 sonrası: Pazartesi kargo
   * - Pazar: Pazartesi kargo
   */
  function getShipDate(parts) {
    var orderDay = dateAtNoon(parts.year, parts.month, parts.day);
    var weekday = getWeekdayIndex(orderDay);
    var timeMinutes = parts.hour * 60 + parts.minute;

    if (weekday === 0) {
      return addCalendarDays(orderDay, 1);
    }

    if (weekday === 6) {
      if (timeMinutes >= SATURDAY_CUTOFF) {
        return addCalendarDays(orderDay, 2);
      }
      return orderDay;
    }

    if (timeMinutes >= WEEKDAY_CUTOFF) {
      return nextBusinessDay(orderDay);
    }

    return orderDay;
  }

  function getDeliveryDate(shipDate) {
    return addCalendarDays(shipDate, DELIVERY_DAYS_AFTER_SHIP);
  }

  function formatDeliveryDate(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0');
    var yyyy = date.getFullYear();
    var dayName = TURKISH_DAYS[getWeekdayIndex(date)];
    return dd + '.' + mm + '.' + yyyy + ' ' + dayName;
  }

  function computeEstimate() {
    var parts = getIstanbulParts(new Date());
    var shipDate = getShipDate(parts);
    var deliveryDate = getDeliveryDate(shipDate);
    return {
      shipDate: shipDate,
      deliveryDate: deliveryDate,
      label: formatDeliveryDate(deliveryDate),
    };
  }

  function updateNodes() {
    var estimate = computeEstimate();
    document.querySelectorAll('[data-be-delivery-estimate]').forEach(function (root) {
      if (root.hasAttribute('data-be-delivery-hidden-empty') && root.closest('.is-empty, .be-cart.is-empty')) {
        root.hidden = true;
        return;
      }

      var dateEl = root.querySelector('[data-be-delivery-date]');
      if (dateEl) {
        dateEl.textContent = estimate.label;
      }

      var shipEl = root.querySelector('[data-be-delivery-ship]');
      if (shipEl) {
        shipEl.textContent = formatDeliveryDate(estimate.shipDate);
      }

      root.hidden = false;
      root.setAttribute('data-be-delivery-ready', 'true');
    });
  }

  function initDeliveryEstimate() {
    updateNodes();
    window.setInterval(updateNodes, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDeliveryEstimate);
  } else {
    initDeliveryEstimate();
  }

  window.BeDeliveryEstimate = {
    compute: computeEstimate,
    format: formatDeliveryDate,
  };
})();
